import FormService from '@/service/FormService';
const formService = new FormService();
import countries from "../../assets/countries.json";
// import ingredients_json from "../assets/ingredients.json";
// import appliances_json from "../assets/appliance-categories.json";
export default {
    namespaced: true,
    state() {
        return {
            active_step:1,
            //terms and conditions
            accept:true,
            email: null,
            //step1
            sex: null,
            dob: null,
            birth_country: null,
            birth_state: null,
            birth_city: null,
            address_country: null,
            address_state: null,
            address_city: null,
            address_zip: null,
            //step2
            no_cook_people: null,
            food_preferences: null,
            available_cooking_time: null,
            cooking_skills: null,
            preferred_course: null,
            preferred_cooking_meal:null,
            sweet_or_savoury: null,
            cooking_times_week: null,
            //step3
            ingredients_allergies: [],
            liked_ingredients:[],
            not_liked_ingredients:[],
            own_connected_appliances: true,
            listAppliances: null,
            //step4
            //recent recipes
            recentRecipesResult: [],
            //preferred recipes
            preferredRecipesResult: [],
            recipes1: [],
            recipes2: [],
            recipes3: [],
            recipes4: [],
            result: null,
            completed: false,
            nRecipesSelected: {
                recentRecipes: 0,
                preferredRecipes: [
                { category: "primi", value: 0 },
                { category: "secondi", value: 0 },
                { category: "contorni", value: 0 },
                { category: "dolci", value: 0 },
                ],
            },
            sexOption: [
                { name: "male", key: "form.sex_option_male" },
                { name: "female", key: "form.sex_option_female" },
                { name: "other", key: "form.sex_option_other" },
            ],
            foodPreferencesOption: [
                { name: "vegetarian", key: "cooking_time.vegetarian" },
                { name: "vegan", key: "cooking_time.vegan" },
                { name: "omnivorous", key: "cooking_time.omnivorous" },
            ],
            availableCookingTimeOption: [
                { name: "lessthan30", key: "cooking_time.lessthan30" },
                { name: "bw30and60", key: "cooking_time.bw30and60" },
                { name: "morethan60", key: "cooking_time.morethan60" },
            ],
            cookingSkillsOption: [
                { name: "verylow", key: "cooking_skills.very_low" },
                { name: "low", key: "cooking_skills.low" },
                { name: "average", key: "cooking_skills.average" },
                { name: "high", key: "cooking_skills.high" },
                { name: "veryhigh", key: "cooking_skills.very_high" },
            ],
            preferredCourseOption: [
                { name: "firstdishes", key: "preferred_course.first_dishes" },
                { name: "secondcourses", key: "preferred_course.second_courses" },
                { name: "dessert", key: "preferred_course.dessert" },
                { name: "side_dishes", key: "preferred_course.side_dishes" },
                { name: "appettizers", key: "preferred_course.appettizers" },
            ],
            preferredCookingMealOption: [
                { name: "breakfast", key: "preferred_cooking_meal.breakfast" },
                { name: "lunch", key: "preferred_cooking_meal.lunch" },
                { name: "dinner", key: "preferred_cooking_meal.dinner" },
                { name: "snack", key: "preferred_cooking_meal.snack" },
            ],
            sweetOrSavouryOption: [
                { name: "sweet", key: "sweet_or_savoury.sweet" },
                { name: "savoury", key: "sweet_or_savoury.savoury" },
                { name: "both", key: "sweet_or_savoury.both" },
            ],
            options: [
                { name: "form.step3_own_appliances_button", value: true },
                { name: "form.step3_dont_own_appliances_button", value: false },
            ],
        }
    },
    getters: {
        nRecipesSelected: state => {
            return state.nRecipesSelected;
        },
        active_step: state => {
            return state.active_step;
        },
        accept: state => {
            return state.accept;
        },
        email: state => {
            return state.email;
        },
        sex: state => {
            return state.sex;
        },
        sexOption: state => {
            return state.sexOption;
        },
        dob: state => {
            return new Date(state.dob);
        },
        birth_country: state => {
            return state.birth_country;
        },
        birth_state: state => {
            return state.birth_state;
        },
        birth_city: state => {
            return state.birth_city;
        },
        address_country: state => {
            return state.address_country;
        },
        address_state: state => {
            return state.address_state;
        },
        address_city: state => {
            return state.address_city;
        },
        address_zip: state => {
            return state.address_zip;
        },
        no_cook_people: state => {
            return state.no_cook_people;
        },
        food_preferences: state => {
            return state.food_preferences;
        },
        foodPreferencesOption: state => {
            return state.foodPreferencesOption;
        },
        available_cooking_time: state => {
            return state.available_cooking_time;
        },
        availableCookingTimeOption: state => {
            return state.availableCookingTimeOption;
        },
        cooking_skills: state => {
            return state.cooking_skills;
        },
        cookingSkillsOption: state => {
            return state.cookingSkillsOption;
        },
        preferred_course: state => {
            return state.preferred_course;
        },
        preferredCourseOption: state => {
            return state.preferredCourseOption;
        },
        preferred_cooking_meal: state => {
            return state.preferred_cooking_meal;
        },
        preferredCookingMealOption: state => {
            return state.preferredCookingMealOption;
        },
        sweet_or_savoury: state => {
            return state.sweet_or_savoury;
        },
        sweetOrSavouryOption: state => {
            return state.sweetOrSavouryOption;
        },
        cooking_times_week: state => {
            return state.cooking_times_week;
        },
        listAppliances: state => {
            return state.listAppliances;
        },
        own_connected_appliances: state => {
            return state.own_connected_appliances;
        },
        options: state => {
            return state.options;
        },
        ingredients_allergies: state => {
            return state.ingredients_allergies;
        },
        liked_ingredients: state => {
            return state.liked_ingredients;
        },
        not_liked_ingredients: state => {
            return state.not_liked_ingredients;
        },
        recentRecipesResult: state => {
            return state.recentRecipesResult;
        },
        preferredRecipesResult: state => {
            return state.preferredRecipesResult;
        },
        recipes1: state => {
            return state.recipes1;
        },
        recipes2: state => {
            return state.recipes2;
        },
        recipes3: state => {
            return state.recipes3;
        },
        recipes4: state => {
            return state.recipes4;
        },
        result: state => {
            return state.result;
        },
        completed: state => {
            return state.completed;
        },
    },
    mutations: {
        nRecipesSelected: function(state , payload) {
            state.nRecipesSelected = payload;
        },
        active_step: function(state , payload) {
            state.active_step = payload;
        },
        accept: function(state , payload) {
            state.accept = payload;
        },
        email: function(state , payload) {
            state.email = payload;
        },
        sex: function(state , payload) {
            state.sex = payload;
        },
        dob: function(state , payload) {
            state.dob = new Date(payload);
        },
        birth_country: function(state , payload) {
            state.birth_country = payload;
        },
        birth_state: function(state , payload) {
            state.birth_state = payload;
        },
        birth_city: function(state , payload) {
            state.birth_city = payload;
        },
        address_country: function(state , payload) {
            state.address_country = payload;
        },
        address_state: function(state , payload) {
            state.address_state = payload;
        },
        address_city: function(state , payload) {
            state.address_city = payload;
        },
        address_zip: function(state , payload) {
            state.address_zip = payload;
        },
        no_cook_people: function(state , payload) {
            state.no_cook_people = payload;
        },
        food_preferences: function(state , payload) {
            state.food_preferences = payload;
        },
        available_cooking_time: function(state , payload) {
            state.available_cooking_time = payload;
        },
        cooking_skills: function(state , payload) {
            state.cooking_skills = payload;
        },
        preferred_course: function(state , payload) {
            state.preferred_course = payload;
        },
        preferred_cooking_meal: function(state , payload) {
            state.preferred_cooking_meal = payload;
        },
        sweet_or_savoury: function(state , payload) {
            state.sweet_or_savoury = payload;
        },
        cooking_times_week: function(state , payload) {
            state.cooking_times_week = payload;
        },
        listAppliances: function(state , payload) {
            state.listAppliances = payload;
        },
        own_connected_appliances: function(state , payload) {
            state.own_connected_appliances = payload;
        },
        ingredients_allergies: function(state , payload) {
            state.ingredients_allergies = payload;
        },
        liked_ingredients: function(state , payload) {
            state.liked_ingredients = payload;
        },
        not_liked_ingredients: function(state , payload) {
            state.not_liked_ingredients = payload;
        },
        recentRecipesResult: function(state , payload) {
            state.recentRecipesResult = payload;
        },
        preferredRecipesResult: function(state , payload) {
            state.preferredRecipesResult = payload;
        },
        recipes1: function(state , payload) {
            state.recipes1 = payload;
        },
        recipes2: function(state , payload) {
            state.recipes2 = payload;
        },
        recipes3: function(state , payload) {
            state.recipes3 = payload;
        },
        recipes4: function(state , payload) {
            state.recipes4 = payload;
        },
        result: function(state , payload) {
            state.result = payload;
        },
        completed: function(state , payload) {
            state.completed = payload;
        },
        removeAll: function (state) {
            state.active_step = 1;
            state.accept = true; 
            state.email = null;
            //step1
            state.sex= null;
            state.dob= null;
            state.birth_country = null,
            state.birth_state = null,
            state.birth_city = null,
            state.address_country = null,
            state.address_state = null,
            state.address_city = null,
            state.address_zip = null,
            //step2
            state.no_cook_people = null;
            state.food_preferences= null;
            state.available_cooking_time= null;
            state.cooking_skills= null;
            state.preferred_course= null;
            state.preferred_cooking_meal= null;
            state.sweet_or_savoury= null;
            state.cooking_times_week= null;
            //step3
            state.ingredients_allergies = [];
            state.liked_ingredients = [];
            state.not_liked_ingredients = [];
            state.own_connected_appliances= true;
            state.listAppliances= null;
            //step4
            //recent recipes
            state.recentRecipesResult= [];
            //preferred recipes
            state.preferredRecipesResult = [];
            state.recipes1= [];
            state.recipes2= [];
            state.recipes3= [];
            state.recipes4 = [];
            state.nRecipesSelected= {
                recentRecipes: 0,
                preferredRecipes: [
                { category: "primi", value: 0 },
                { category: "secondi", value: 0 },
                { category: "contorni", value: 0 },
                { category: "dolci", value: 0 },
                ],
            },
            state.result= null;
        },
    },
    actions: {
        async createuser(context, payload) {
            let response = await formService.createUser(payload)
            context.commit("result", response);
            return response;
        },
         getElements: function (context, payload) {
            let elements = [];
            payload.forEach(function (arrayItem) {
                elements.push(arrayItem.id);
            });
            return elements;
        },
        async modifyuser(context) {
            let dobDate = new Date(context.state.dob);
            let ingredients = context.state.ingredients_allergies != null ? await context.dispatch("getElements", context.state.ingredients_allergies) : null;
            let liked_ingredients = context.state.liked_ingredients !=null ? await context.dispatch("getElements", context.state.liked_ingredients): null;
            let not_liked_ingredients = context.state.not_liked_ingredients != null ? await context.dispatch("getElements", context.state.not_liked_ingredients) : null;
            let appliances = context.state.listAppliances!=null ? await context.dispatch("getElements", context.state.listAppliances): null;
            let recent_recipes = context.state.recentRecipesResult!=null ? await context.dispatch("getElements", context.state.recentRecipesResult) : null;
            let liked_recipes = context.state.recipes1!=null && context.state.recipes2!=null && context.state.recipes3!=null && context.state.recipes4!=null ? await context.dispatch("getElements", [...context.state.recipes1, ...context.state.recipes2,...context.state.recipes3,...context.state.recipes4]) : null;
            let data = {
                "terms_and_conditions": context.state.accept,
                "sex": context.state.sex!= null ? context.state.sex.name : null,
                "dob": context.state.dob!=null ? new Date(dobDate.getTime() - dobDate.getTimezoneOffset() * 60000).toISOString(): null,
                "address_state": context.state.address_state!=null ? context.state.address_state : null,
                "address_country": context.state.address_country!=null ? context.state.address_country.name : null,
                "address_city": context.state.address_city!=null ? context.state.address_city : null,
                "address_zip": context.state.address_zip!=null ? context.state.address_zip : null,
                "birth_country": context.state.birth_country!=null ? context.state.birth_country.name : null,
                "birth_state": context.state.birth_state!=null ? context.state.birth_state : null,
                "birth_city": context.state.birth_city!=null ? context.state.birth_city : null,
                "no_cook_people": context.state.no_cook_people!=null ? Number(context.state.no_cook_people): null,
                "food_preferences": context.state.food_preferences!=null ? context.state.food_preferences.name : null, 
                "available_cooking_time": context.state.available_cooking_time!=null ? context.state.available_cooking_time.name : null,
                "cooking_skills": context.state.cooking_skills!=null ? context.state.cooking_skills.key : null,
                "preferred_course": context.state.preferred_course!=null ? context.state.preferred_course.key : null,
                "preferred_cooking_meal": context.state.preferred_cooking_meal!=null ? context.state.preferred_cooking_meal.key : null,
                "sweet_or_savoury": context.state.sweet_or_savoury!=null ? context.state.sweet_or_savoury.key : null,
                "cooking_times_week": context.state.cooking_times_week != null ? Number(context.state.cooking_times_week) : null,
                "ingredients_allergies": context.state.ingredients_allergies != null ? ingredients : null,
                "liked_ingredients": context.state.liked_ingredients != null ? liked_ingredients : null,
                "not_liked_ingredients": context.state.not_liked_ingredients != null ? not_liked_ingredients : null,
                "own_connected_appliances": context.state.own_connected_appliances != null ? context.state.own_connected_appliances.value : null,
                "wish_connected_appliances": context.state.own_connected_appliances.value ===false ? appliances: null,
                "owned_connected_appliances": context.state.own_connected_appliances.value === true ? appliances : null,
                "recent_recipes": context.state.recentRecipesResult !=null ? recent_recipes : null,
                "liked_recipes": context.state.recipes1!=null && context.state.recipes2!=null && context.state.recipes3!=null && context.state.recipes4!=null ? liked_recipes : null
            }
            let response = await formService.modifyUser(context.state.result.id,data);
            context.commit("result", response);
            return response;
        },
        async unsubscribe(context, payload) {
            let response = await formService.modifyUser(payload, { email_notification: false });
            return response;
        },
        async getUser(context, payload) {
            let response = await formService.getUser(payload.id);
            context.state.result = {};
            //inizio
            context.state.active_step = 1;
            context.state.accept = response.terms_and_conditions || true; 
            context.state.email = response.email;
            //step1
            context.state.sex= context.state.sexOption.find(o => o.name === response.sex);
            context.state.dob= response.dob;
            context.state.birth_country = countries.find(o => o.name === response.birth_country);
            context.state.birth_state = response.birth_state;
            context.state.birth_city = response.birth_city;
            context.state.address_country = countries.find(o => o.name === response.address_country);
            context.state.address_state = response.address_state;
            context.state.address_city = response.address_city;
            context.state.address_zip = response.address_zip;
            if (context.state.sex != null &&
                context.state.dob != null &&
                context.state.birth_country != null &&
                context.state.birth_state != null &&
                context.state.birth_city != null &&
                context.state.address_country != null &
                context.state.address_state != null &&
                context.state.address_city != null && 
                context.state.address_zip != null) {
                //step2
                context.state.active_step = 2;
                context.state.no_cook_people = response.no_cook_people;
                context.state.food_preferences= context.state.foodPreferencesOption.find(o => o.name === response.food_preferences);
                context.state.available_cooking_time= context.state.availableCookingTimeOption.find(o => o.name === response.available_cooking_time);
                context.state.cooking_skills= context.state.cookingSkillsOption.find(o => o.key === response.cooking_skills);
                context.state.preferred_course= context.state.preferredCourseOption.find(o => o.key === response.preferred_course);
                context.state.preferred_cooking_meal= context.state.preferredCookingMealOption.find(o => o.key === response.preferred_cooking_meal);
                context.state.sweet_or_savoury= context.state.sweetOrSavouryOption.find(o => o.key === response.sweet_or_savoury);
                context.state.cooking_times_week = response.cooking_times_week; 
                if (context.state.no_cook_people != null &&
                    context.state.food_preferences != null &&
                    context.state.available_cooking_time != null &&
                    context.state.cooking_skills != null &&
                    context.state.preferred_course != null &&
                    context.state.preferred_cooking_meal != null &&
                    context.state.sweet_or_savoury != null &&
                    context.state.cooking_times_week) {
                    //step3
                    context.state.active_step = 3;
                    context.state.ingredients_allergies = response.ingredients_allergies.map(item => {
                        return {
                            id: item.id,
                            attributes: {
                                key: item.key,
                                labels: {
                                    data: item.labels.map(label => {
                                        return {
                                            attributes: {
                                                locale: label.locale,
                                                value: label.value
                                            }
                                        }
                                    })
                                }
                            }
                        }
                    });
                    context.state.liked_ingredients = response.liked_ingredients.map(item => {
                        return {
                            id: item.id,
                            attributes: {
                                key: item.key,
                                labels: {
                                    data: item.labels.map(label => {
                                        return {
                                            attributes: {
                                                locale: label.locale,
                                                value: label.value
                                            }
                                        }
                                    })
                                }
                            }
                        }
                    });
                    context.state.not_liked_ingredients = response.not_liked_ingredients.map(item => {
                        return {
                            id: item.id,
                            attributes: {
                                key: item.key,
                                labels: {
                                    data: item.labels.map(label => {
                                        return {
                                            attributes: {
                                                locale: label.locale,
                                                value: label.value
                                            }
                                        }
                                    })
                                }
                            }
                        }
                    });
                    
                        //step4
                        //recent recipes
                        context.state.active_step = 4;
                        context.state.recentRecipesResult = response.recent_recipes.map( item => {
                            let coverImage;
                            const regex = new RegExp(/_[0-9].*_/);
                            item.media.forEach((element) => {
                                if (!regex.test(element.url)) {
                                coverImage = element.url;
                                }
                            });
                            let recipeTitle = item.labels.find((o) => o.locale === payload.locale);
                            recipeTitle=recipeTitle.title;    
                        return {
                            id: item.id,
                            key: item.key,
                            image: coverImage,
                            name: recipeTitle
                        }
                    });
                        if (context.state.recentRecipesResult.length>4) {
                            context.state.active_step = 5;
                            response.liked_recipes.map(item => {
                                let coverImage;
                                const regex = new RegExp(/_[0-9].*_/);
                                item.media.forEach((element) => {
                                    if (!regex.test(element.url)) {
                                    coverImage = element.url;
                                    }
                                });
                                let recipeTitle = item.labels.find((o) => o.locale === payload.locale);
                                recipeTitle=recipeTitle.title;    
                                let recipe = {
                                    id: item.id,
                                    key: item.key,
                                    image: coverImage,
                                    name: recipeTitle
                                }
                                if (item.category.key === "category.first_dishes") {
                                    context.state.recipes1.push(recipe);
                                } else if (item.category.key === "category.second_courses") {
                                    context.state.recipes2.push(recipe);
                                } else if (item.category.key === "category.side_dishes" || 
                                           item.category.key === "category.appetizers" ||
                                           item.category.key === "category.salads"){
                                    context.state.recipes3.push(recipe);
                                }else if (item.category.key === "category.dessert") {
                                    context.state.recipes4.push(recipe);
                                }
                            });
                            if (context.state.recipes1.length > 4) {
                                context.state.active_step = 6;
                                if (context.state.recipes2.length > 4) {
                                    context.state.active_step = 7;
                                    if (context.state.recipes3.length > 4) {
                                        context.state.active_step = 8;
                                        if (context.state.recipes4.length > 4) {
                                            context.state.active_step = 1;
                                        }
                                    }
                                }
                            }
                        }
                        context.state.nRecipesSelected = {
                            recentRecipes: context.state.recentRecipesResult.length,
                            preferredRecipes: [
                                { category: "primi", value: context.state.recipes1.length },
                                { category: "secondi", value: context.state.recipes2.length },
                                { category: "contorni", value: context.state.recipes3.length },
                                { category: "dolci", value: context.state.recipes4.length },
                            ],
                        };
                }
            }    
            context.state.result= response;
            //fine
            if (context.state.recipes1.legth > 4 && context.state.recipes2.legth > 4 && context.state.recipes3.legth > 4 && context.state.recipes4.legth > 4) {
                context.state.own_connected_appliances= context.state.options.find(o => o.value === response.own_connected_appliances);
                context.state.listAppliances = (response.owned_connected_appliances || response.wish_connected_appliances).map(item => {
                    return {
                        id: item.id,
                        attributes: {
                            category: item.category
                        }
                    }
                });
                if (context.state.own_connected_appliances.value == false ||
                    context.state.own_connected_appliances.value == true && context.state.listAppliances != null) {
                    context.state.completed = true;
                }
            }
            return response;
        },
    }
};